module.exports = __webpack_public_path__ + "img/startup.8085d5da.webp";